import React, { useState, useEffect } from "react";

export const Navigation = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <>
      <style>{`
        #menu {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 9000;
          width: 100%;
          box-sizing: border-box;
          transition: all 0.4s ease;

          /*  GLASS EFFECT  */
          background: ${scrolled
            ? "rgba(255, 255, 255, 0.65)"
            : "rgba(255, 255, 255, 0.25)"};
          backdrop-filter: blur(${scrolled ? "20px" : "12px"}) saturate(180%);
          -webkit-backdrop-filter: blur(${scrolled ? "20px" : "12px"}) saturate(180%);
          border-bottom: 1px solid ${scrolled
            ? "rgba(255, 255, 255, 0.6)"
            : "rgba(255, 255, 255, 0.3)"};
          box-shadow: ${scrolled
            ? "0 4px 24px rgba(0,0,0,0.10), inset 0 1px 0 rgba(255,255,255,0.7)"
            : "0 2px 12px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.4)"};
        }

        #menu .nav-container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 16px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 60px;
        }

        #menu .nav-brand {
          font-size: 16px;
          font-weight: 800;
          letter-spacing: 1.5px;
          color: #1a1a2e;
          text-decoration: none;
          text-transform: uppercase;
          white-space: nowrap;
          flex-shrink: 0;
          transition: color 0.3s ease;
          text-shadow: 0 1px 2px rgba(255,255,255,0.6);
        }

        #menu .nav-brand:hover {
          color: #337ab7;
          text-decoration: none;
        }

        #menu .nav-toggle {
          display: none;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 5px;
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.3);
          border: 1px solid rgba(255,255,255,0.5);
          border-radius: 10px;
          cursor: pointer;
          padding: 4px;
          flex-shrink: 0;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          transition: background 0.3s ease;
        }

        #menu .nav-toggle:hover {
          background: rgba(255,255,255,0.5);
        }

        #menu .nav-toggle span {
          display: block;
          width: 24px;
          height: 2px;
          background: #333;
          border-radius: 2px;
          transition: all 0.3s ease;
        }

        #menu .nav-toggle.open span:nth-child(1) {
          transform: translateY(7px) rotate(45deg);
        }
        #menu .nav-toggle.open span:nth-child(2) {
          opacity: 0;
        }
        #menu .nav-toggle.open span:nth-child(3) {
          transform: translateY(-7px) rotate(-45deg);
        }

        #menu .nav-links {
          display: flex;
          flex-direction: row;
          align-items: center;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 4px;
        }

        #menu .nav-links li a {
          display: block;
          padding: 7px 11px;
          font-size: 13px;
          font-weight: 600;
          color: #333;
          text-decoration: none;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          border-radius: 8px;
          transition: all 0.25s ease;
          white-space: nowrap;
          position: relative;
        }

        #menu .nav-links li a:hover {
          color: #337ab7;
          background: rgba(255, 255, 255, 0.5);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          box-shadow: 0 2px 8px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.8);
          text-decoration: none;
        }

        /* Mobile */
        @media (max-width: 767px) {
          #menu .nav-toggle {
            display: flex;
          }
          #menu .nav-links {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 60px;
            left: 0;
            right: 0;
            width: 100%;

            /* Glass effect for mobile dropdown */
            background: rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(24px) saturate(180%);
            -webkit-backdrop-filter: blur(24px) saturate(180%);
            border-bottom: 1px solid rgba(255,255,255,0.5);
            box-shadow: 0 12px 32px rgba(0,0,0,0.10), inset 0 1px 0 rgba(255,255,255,0.7);

            padding: 8px 12px 14px;
            box-sizing: border-box;
            gap: 4px;
          }
          #menu .nav-links.open {
            display: flex;
          }
          #menu .nav-links li {
            width: 100%;
          }
          #menu .nav-links li a {
            padding: 11px 16px;
            font-size: 14px;
            border-radius: 10px;
            width: 100%;
            box-sizing: border-box;
            border-bottom: none;
          }
          #menu .nav-links li a:hover {
            background: rgba(255,255,255,0.65);
          }
        }
      `}</style>

      <nav id="menu">
        <div className="nav-container">
          <a className="nav-brand" href="#page-top" onClick={handleNavClick}>
            COREBUILD SOLUTION
          </a>

          <button
            className={`nav-toggle ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
            <li><a href="#about" className="page-scroll" onClick={handleNavClick}>About</a></li>
            <li><a href="#features" className="page-scroll" onClick={handleNavClick}>Product</a></li>
            <li><a href="#services" className="page-scroll" onClick={handleNavClick}>Services</a></li>
            <li><a href="#portfolio" className="page-scroll" onClick={handleNavClick}>Gallery</a></li>
            <li><a href="#testimonials" className="page-scroll" onClick={handleNavClick}>Testimonials</a></li>

            <li><a href="#contact" className="page-scroll" onClick={handleNavClick}>Contact</a></li>
          </ul>
        </div>
      </nav>
    </>
  );
};